import React from 'react';

//local dependencies
import { memberAddEditAddresspreloader } from 'ui/views/widgets/memberAddEditAddress';
import { MemberAddEditPaymentInformation } from 'ui/containers/MemberAddEditPaymentInformation';
import { withNetworkState } from 'ui/hoc/withNetworkState';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { memberCheckoutPaymentOptions as MemberCheckoutPaymentOptions } from 'ui/views/widgets/memberCheckoutPaymentOptions';
 *
 * // render
 * <MemberCheckoutPaymentOptions propName='propValue'/>
 */
const _memberCheckoutPaymentOptions = ( props ) => {

    return (
        <div className='ui-member-checkout-payment-options'>
            <MemberAddEditPaymentInformation
                enableSelection={ true }
                disabled={ ! props.isPaymentRequired }
                { ...props }
            />
        </div>
    );
};

// set display name
_memberCheckoutPaymentOptions.displayName = 'memberCheckoutPaymentOptions';

// set default props
_memberCheckoutPaymentOptions.defaultProps = {};

// prop types
_memberCheckoutPaymentOptions.propTypes = {};


export const memberCheckoutPaymentOptions = withNetworkState( memberAddEditAddresspreloader, _memberCheckoutPaymentOptions );
